import { Col, Row, message, Image, InputNumber } from 'antd'
import React, { useState, useEffect, useMemo } from 'react'
import { getCashCodes } from '../../api/response'
import API_URL from '../../config/api'
import styled from 'styled-components'
import { useAppSelector } from '../../redux/reduxHooks'
import { homePageData } from '../../redux/reducers/homePage_reducer'
import { orderData } from '../../redux/reducers/orders_reducer'
import { useRouteMatch } from 'react-router-dom'

const Img = styled(Image)`
  object-fit: contain;
  height: 100% !important;
  width: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 1200px) {
    object-fit: cover;
    height: 100% !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
const StyledInputNumber = styled(InputNumber)`
  min-width: 100px !important;

`
interface Props {
  setChargeItems?: (chargeItems) => void
  setCashItems?: (cashItems) => void
  chargeItems?: { value: number; quantity: number }[]
  cashItems?: { value: number; quantity: number }[]
  type: 'income' | 'charge' | 'withdraw' | 'deposit' | 'other'
}
const CashItems = ({ setCashItems, setChargeItems, chargeItems, cashItems, type }: Props) => {
  const [cashCodes, setCashCodes] = useState<{ value: number; name: string; image: string; id: number }[]>()
  const configData = useAppSelector(homePageData)
  const { credit } = useAppSelector(homePageData)
  const { placeOrderPrice } = useAppSelector(orderData)
  const match = useRouteMatch<{ id: string }>()
  const cashSelector = (type: 'income' | 'charge' | 'withdraw' | 'deposit' | 'other') => {
    return (
        <Row style={{width: '600px'}}>
          {cashCodes.map((item, index) => {
            return (
              <Col span={12} key={index}>
                <Row wrap={false} align="middle">
                  <Col span={14}>
                    <Row wrap={false} align="middle">
                      <Col span={14}>
                        <Image
                          preview={false}
                          src={`${API_URL.cdn}${item.image}`}
                          fallback='data:image/png;base64,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'
                        />
                      </Col>
                      <Col span={10} style={{paddingLeft: '5px'}}>
                        ${item.value.toFixed(2)}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={10}>
                    <StyledInputNumber
                      tabIndex={item.id}
                      min={0}
                      defaultValue={
                        type === 'charge'
                          ? chargeItems.find((a) => a.value === item.value).quantity
                          : cashItems.find((a) => a.value === item.value)?.quantity||0
                      }
                      onChange={(num: number) => { 
                        if (type === 'charge') {
                          setChargeItems &&
                            setChargeItems(
                              chargeItems.map((cash) => {
                                if (cash.value === item.value) {
                                  return { value: item.value, quantity: num }
                                }
                                return cash
                              })
                            )
                        } else {
                          setCashItems &&
                            setCashItems(
                              cashItems.map((cash) => {
                                if (cash.value === item.value) {
                                  return { value: item.value, quantity: num }
                                }
                                return cash
                              })
                            )
                        }
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            )
          })}
        </Row>
    )
  }
  const getCashCodesMethod = async () => {
    const res = await getCashCodes()
    if (res.success) {
      const reorderList = res.data.map((item) => {
        switch (item.value) {
          case 100:
            return { ...item, id: 1 }
          case 50:
            return { ...res.data.find((a) => a.value === 2), id: 6 }
          case 20:
            return { ...res.data.find((a) => a.value === 50), id: 2 }
          case 10:
            return { ...res.data.find((a) => a.value === 1), id: 7 }
          case 5:
            return { ...res.data.find((a) => a.value === 20), id: 3 }
          case 2:
            return { ...res.data.find((a) => a.value === 0.5), id: 8 }
          case 1:
            return { ...res.data.find((a) => a.value === 10), id: 4 }
          case 0.5:
            return { ...res.data.find((a) => a.value === 0.2), id: 9 }
          case 0.2:
            return { ...res.data.find((a) => a.value === 5), id: 5 }
          case 0.1:
            return { ...item, id: 10 }
          default:
            break
        }
        return { ...item, id: 0 }
      })
      setCashCodes(reorderList)
    } else {
      message.error(res.message)
    }
  }

  useEffect(() => {
    getCashCodesMethod()
  }, [configData.lang, match.params.id, placeOrderPrice, credit])

  return <>{cashCodes && cashSelector(type)}</>
}

export default CashItems
